var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1EBC30;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 6.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.2132 15)",
    className: "st0",
    width: 2.9,
    height: 17.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 6.3,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 15 -6.2132)",
    className: "st0",
    width: 2.9,
    height: 17.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCross);
export default __webpack_public_path__ + "static/media/green_cross.413132a4828eb6932cc12829f74f44ed.svg";
export { ForwardRef as ReactComponent };